import React from 'react';
import PropTypes from 'prop-types';

import { useCurrentLanguage } from 'tradera-lang/translate';
import { formatPrice } from 'tradera-utils/format';

const PriceLabel = ({ tagName: TagName, className, price, hasDiscount }) => {
    const { language } = useCurrentLanguage();
    if (price) {
        return (
            <TagName
                className={`${hasDiscount ? 'text-danger' : ''} ${className}`}>
                {formatPrice(price, language, {
                    // Swedish locale shows "kr", other "SEK"
                    currencyDisplay: language.startsWith('sv')
                        ? 'symbol'
                        : 'code'
                })}
            </TagName>
        );
    } else {
        return null;
    }
};
PriceLabel.propTypes = {
    tagName: PropTypes.string,
    className: PropTypes.string,
    price: PropTypes.number,
    hasDiscount: PropTypes.bool
};
PriceLabel.defaultProps = {
    tagName: 'span',
    className: ''
};

export default PriceLabel;
